module.exports = __webpack_public_path__ + "img/match.2928b272.svg";